<template>
  <div>
    <div class="d-flex justify-content-center mb-1">
      <b-spinner
        variant="success"
        span="Spinning"
        block
        v-if="loadingSpinner"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>

    <section class="invoice-preview-wrapper" v-if="!loadingSpinner">
      <b-row class="invoice-preview">
        <!-- Col: Left (Invoice Container) -->
        <b-col cols="12" xl="9" md="8">
          <validation-observer v-slot="{ invalid }" ref="purchaseorder">
            <b-form @submit.prevent>
          <b-card
            no-body
            class="invoice-preview-card"
            id="invoice-preview-card"
            style="display: block; width: 100%"
          >
            <b-card-body class="invoice-padding pb-0">
              <div class="row align-items-center mb-2">
                <div class="">
                  <Logo />
                </div>
                <div class="col-9">
                  <div class="">
                    <CompanyName />
                  </div>
                  <div class="">
                    <Address />
                  </div>
                </div>
              </div>

              <b-row class="invoice-spacing align-items-start">
                
                <!-- Left Section: Send To -->
                <b-card-body class="invoice-padding pt-0">
                  <b-row class="invoice-spacing">
                    <!-- Col: Invoice To -->
                    <b-col cols="6" xl="6" class="mb-lg-1">
                      <h6 class="mb-2">Send to:*</h6>
                      <validation-provider
                        rules="required"
                        v-slot="{ errors }"
                        name="Supplier"
                        vid="supplierId"
                      >
                        <b-form-select
                          v-model="whenSelected.id"
                          :options="optionsCustomer"
                          placeholder="select supplier"
                          @change="supplierSelected"
                        />
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                     
                    </b-col>
                  </b-row>
                </b-card-body>

                <!-- Right Section: Order Details -->
                <b-col
                  cols="12"
                  md="6"
                  xl="6"
                  class="p-0 d-flex justify-content-end"
                >
                  <div class="invoice-number-date">
                    <div
                      class="d-flex align-items-center justify-content-md-end mb-1"
                    >
                      <h4>
                        {{ headerName }} #{{ orderNumber }}
                      </h4>
                    </div>
                    <div class="d-flex align-items-center my-2">
                      <span class="title"> Issued Date: </span>
                      <flat-pickr
                        v-model="issuedDate"
                        class="form-control invoice-edit-input"
                      />
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="title"> Due Date: </span>
                      <flat-pickr
                        v-model="dueDate"
                        class="form-control invoice-edit-input"
                      />
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Invoice Description: Table -->
            <b-card-body class="invoice-padding">
              <div ref="form" class="repeater-form">
                <b-row
                  v-for="(item, index) in invoiceData.items"
                  :key="index"
                  ref="row"
                  class="pb-2"
                >
                  <!-- Item Form -->
                  <!-- ? This will be in loop => So consider below markup for single item -->
                  <b-col cols="12">
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <!-- Form Input Fields OR content inside bordered area  -->
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-flex border rounded">
                      <b-row class="flex-grow-1 p-2">
                        <!-- Single Item Form Headers -->
                        <b-col cols="12" lg="6">
                          <label class="static-label">Items*</label>
                          <div class="d-flex">
                            <div class="flex-grow-1 mr-1">
                              <validation-provider
                                rules="required"
                                v-slot="{ errors }"
                                name="Item"
                                :vid="`Item_${index}`"
                              >
                                <v-select
                                  v-model="item.name"
                                  :options="optionsProduct"
                                  label="itemTitle"
                                  :dir="
                                    $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                                  "
                                  :clearable="false"
                                  :searchable="true"
                                  :class="[
                                    { 'is-invalid': errors.length },
                                    'item-selector-title',
                                  ]"
                                  placeholder="Select Item"
                                  @input="(val) => updateItemForm(index, val)"
                                >
                                  <template
                                    #option="{
                                      itemTitle,
                                      categoryName,
                                      subCategoryName,
                                    }"
                                  >
                                    <div
                                      style="
                                        display: flex;
                                        flex-direction: column;
                                      "
                                    >
                                      <span>{{ itemTitle }}</span>
                                      <span
                                        >{{ categoryName || "-" }} :
                                        {{ subCategoryName || "-" }}</span
                                      >
                                    </div>
                                  </template>
                                </v-select>

                                <small
                                  v-if="errors.length"
                                  class="text-danger"
                                  >{{ errors[0] }}</small
                                >
                              </validation-provider>
                            </div>
                          </div>
                        </b-col>
                        <b-col
                          v-if="!purchaseorderId.hidePrice"
                          cols="12"
                          lg="2"
                        >
                          <label class="static-label">Unit Price (Rs)</label>
                          <validation-provider
                            rules="min_value:0"
                            v-slot="{ errors }"
                            name="Unit Price"
                            :vid="`UnitPrice_${index}`"
                          >
                            <b-form-input
                              v-model="item.purchase"
                              type="number"
                              @keypress="allowOnlyNumbers($event)"
                            />
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="2">
                          <label class="static-label">Qty*</label>

                          <validation-provider
                            rules="required|min_value:1"
                            v-slot="{ errors }"
                            name="Quantity"
                            :vid="`Quantity_${index}`"
                          >
                            <b-form-input
                              v-model="item.qty"
                              @keypress="allowOnlyNumbers($event)"
                            />
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </validation-provider>
                        </b-col>
                        <b-col
                          v-if="!purchaseorderId.hidePrice"
                          cols="12"
                          lg="2"
                        >
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <div class="flex-grow-1">
                              <label class="static-label">Total Price</label>
                              <p class="mb-1">
                                Rs
                                {{
                                  isNaN(item.purchase) || isNaN(item.qty)
                                    ? "0"
                                    : (item.purchase * item.qty).toFixed(2)
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="mt-1 mb-1">
                            <b-button
                              variant="danger"
                              size="sm"
                              @click="removeItem(index)"
                            >
                              Remove
                            </b-button>
                          </div>
                        </b-col>
                        <b-col cols="12" lg="12">
                          <span class="d-inline d-lg-none">Description</span>
                          <b-form-textarea
                            v-model="item.description"
                            class="mb-2 mb-lg-0"
                          />
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="primary"
                @click="addNewItemInItemForm"
              >
                Add Item
              </b-button>
            </b-card-body>

            <b-card-body class="invoice-padding pb-0">
              <b-row>
                <!-- Col: Sales Persion -->
                <b-col
                  cols="12"
                  md="4"
                  class="mt-md-0 mt-3 d-flex align-items-center"
                  order="2"
                  order-md="1"
                >
                  <div class="w-100">
                    <span
                      for="invoice-data-sales-person"
                      class="text-nowrap mr-50"
                      >Sales Person:</span
                    >
                    <validation-provider
                      rules="required"
                      v-slot="{ errors }"
                      name="Sales Person"
                      vid="Sales Person"
                    >
                      <b-form-select
                        v-model="salesPersonId"
                        :options="optionsSalesPerson"
                      />
                      <small v-if="errors.length" class="text-danger">{{
                        errors[0]
                      }}</small>
                    </validation-provider>
                  </div>
                </b-col>

                <!-- Col: Total -->

                <b-col
                  cols="12"
                  md="8"
                  class="mt-md-6 d-flex justify-content-end"
                  order="1"
                  order-md="2"
                >
                  <div class="invoice-total-wrapper">
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Total:</p>
                      <p class="invoice-total-amount">
                        {{ finalTotal }}
                      </p>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <hr class="invoice-spacing" />

            <b-card-body class="invoice-padding pt-0">
              <span class="font-weight-bold">Note: </span>
              <b-form-textarea
                v-model="note"
                class="form-control invoice-edit-input"
              />
            </b-card-body>
          </b-card>
        </b-form>
      </validation-observer>
        </b-col>

        <b-col cols="12" md="4" xl="3" class="invoice-actions">
          <b-card>
            <b-button variant="outline-primary" class="mb-75" block @click="addSalesOrder()"
            :disabled="loadingButton"
            :style="loadingButton ? { cursor: 'not-allowed' } : {}">
              Save
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>


<script>
import Logo from "@core/layouts/components/Logo.vue";
import { ref, watch } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import { debounce } from "lodash";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormSelect,
  BSpinner,
  BFormInput,
  BFormTextarea,
} from "bootstrap-vue";
import Address from "@core/layouts/components/Address.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { heightTransition } from "@core/mixins/ui/transition";
import { required } from "vee-validate/dist/rules";
import {customSwal, customError, customLoader, fnSortingDropdown,} from "@/libs/customFn";
extend("required", {...required, message: "{_field_} field is required",});
import "@/libs/customValidation";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormSelect,
    BSpinner,
    BFormInput,
    BFormTextarea,
    flatPickr,
    Logo,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    Address,
    CompanyName,
  },
  mixins: [heightTransition],
  directives: {
    ripple: Ripple,
  },
  data() {
    return {
      isVisible: true,
      supplierId: null,
      ids: this.$route.query.itemIds
        ? this.$route.query.itemIds.split(",").map((id) => {
            const [itemId, quantity] = id.split("_");
            return { id: itemId, quantity: parseInt(quantity) || 1 }; // Ensure quantity is always valid
          })
        : [],
      whenSelected: [],
      warehouseId: null,
      quantity: 1,
      quantityError: "",
      MaindiscountType: 0,
      MainDiscount: 0,
      invoiceData: {
        items: [],
      },
      itemFormBlankItem: {
        item: null,
      value: null,
      name: "",
      computedPrice: 0,
      purchase: 0,
      qty: 1,
      profit: 0,
      description: "",
      cost: 0,
    },
      issuedDate: "",
      dueDate: "",
      hidePrice: false,
      orderNumber: "",
      salesPersonId: "",
      
      optionsSalesPerson: [],
      note: "",
      loadingSpinner: false,
      loadInvoiceData: true,
      optionsProduct: [],
      optionsCustomer: [],
      optionsWarehouse: [],
      fields: [], // ✅ Initialize `fields` to prevent errors
      config: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/Y",
        allowInput: true,
        disable: [new Date()],
      },
      configDue: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/Y",
        allowInput: true,
        minDate: new Date(),
      },
      totalPrice: 0, // Initialize totalPrice
      disabledItem: true,
      loadingButton: false,

    };
  },
  computed: {
    dynamicFields() {
      const dynamicFields = [...this.fields]; // ✅ Ensure `fields` exists
      if (!this.purchaseorderId?.hidePrice) {
        // ✅ Use optional chaining
        dynamicFields.push({ key: "cost", span: "Unit Price (Rs)" });
        dynamicFields.push({ key: "price", span: "Total Price (Rs)" });
      }
      return dynamicFields;
    },
    headerName() {
      return this.purchaseorderId?.hidePrice ? "RFP" : "Purchase Order"; // ✅ Use optional chaining
    },

    discountTotal() {
      let mainDiscount = Number(this.MainDiscount);

      if (this.MaindiscountType === 0) {
        if (mainDiscount == 0) return 0;

        return (mainDiscount / 100) * this.totalCost;
      } else {
        return mainDiscount;
      }
    },
    subTotal() {
      return this.totalCost;
    },
    finalTotal() {
      let total = this.subTotal;
      return total.toFixed(2);
    },
    ...mapGetters("productModule", {
      ProductList: "product",
      productID: "productID",
      loading: "loading",
    }),
    ...mapGetters("rawmaterialModule", {
      RawMaterialList: "rawmaterials",
      rawmaterialsID: "rawmaterialsID",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("purchaseOrderModule", {
      purchaseOrderList: "purchaseorders",
      purchaseorderId: "purchaseorderId",
      loading: "loading",
      documents: "documents",
      file: "file",
    }),
    ...mapGetters("warehouseModule", {
      warehouses: "warehouse",
      warehouseLoading: "loading",
    }),
    ...mapGetters("supplierModule", {
      SupplierList: "suppliers",
      supplierLoading: "loading",
    }),
    totalCost() {
      let total = 0;
      this.invoiceData.items.forEach((item) => {
        total += item.purchase * item.qty;
      });
      if (isNaN(parseFloat(total.toFixed(2)))) {
        return 0;
      }
      return parseFloat(total.toFixed(2));
    },
  },
  methods: {
    allowOnlyNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;

      if (
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 8
      ) {
        event.preventDefault();
      }

      if (charCode === 46 && event.target.value.includes(".")) {
        event.preventDefault();
      }
    },
    ...mapActions("productModule", [
      "getProductListAction",
      "getProductIDAction",
    ]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    ...mapActions("supplierModule", [
      "getSupplierListAction",
      "getSupplierByIDAction",
    ]),
    ...mapActions("purchaseOrderModule", [
      "getPurchaseOrdersByIDAction",
      "getPurchaseOrdersListAction",
      "removePurchaseOrdersAction",
      "updatePurchaseOrdersAction",
      "getPurchaseOrderDocumentListAction",
    ]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("rawmaterialModule", [
      "getRawMaterialListAction",
      "getRawMaterialListByIdAction",
    ]),
    removeItem(index) {
      this.invoiceData.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
      // Recalculate total price after removing the item
      this.recalculatePrices();
    },

    async supplierSelected(id) {
      this.whenSelected = this.SupplierList.find(supplier => supplier.id === id);

},

    async initializeItemData() {
      this.loadInvoiceData = true;
      try {
        let totalPrice = 0;
        for (const item of this.ids) {
          const product = await this.getProductIDAction(item.id);
          if (product) {
            const { id, name, purchasePrice, qty = 1 } = product;
            const quantity =
              !isNaN(item.quantity) && item.quantity > 0 ? item.quantity : 1;
            const itemTotalPrice = parseFloat(purchasePrice) * quantity;

            this.invoiceData.items.push({
              id,
              name,
              purchase: purchasePrice,
              qty: quantity,
              computedPrice: itemTotalPrice.toFixed(2),
              description: "",
              tax: 0,
              profit: 0,
              discount: 0,
              disabledItem: true,
            });

            totalPrice += itemTotalPrice;
          }
        }

        this.totalPrice = totalPrice.toFixed(2);
      } catch (error) {
        console.error("Error initializing data:", error);
      } finally {
        this.loadInvoiceData = false;
      }
    },
    //   updateItemForm(index, val) {
    // const selectedItem = this.optionsProduct.find(
    //   (option) => option.value === val.value
    // );
    // if (selectedItem) {
    //   const item = this.invoiceData.items[index];
    //   item.name = selectedItem.itemTitle;
    //   item.cost = selectedItem.purchase;
    //   item.qty = selectedItem.qty;
    //   item.computedPrice = (selectedItem.purchase * selectedItem.qty).toFixed(2); // Ensure computed price is calculated
    //   item.description = selectedItem.description;
    //   item.tax = selectedItem.tax;
    //   item.profit = selectedItem.profit;
    //   item.id = selectedItem.itemTitle;
    //   this.recalculatePrices(); // Recalculate total price after updating the item
    // }
    //   },
    addNewItemInItemForm() {
      this.invoiceData.items.push(
        JSON.parse(JSON.stringify(this.itemFormBlankItem))
      );
      console.log(
        "🚀 ~ addNewItemInItemForm ~ this.invoiceData.items:",
        this.invoiceData.items
      );

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          this.$refs.form.style.overflow = null;
        }, 350);
      });
    },

    recalculatePrices() {
      this.totalPrice = this.invoiceData.items
        .reduce((total, item) => {
          return total + parseFloat(item.computedPrice);
        }, 0)
        .toFixed(2);
    },
   
    // addNewItemInItemForm() {
    //   // Add item to the list of items, ensuring to include item IDs
    //   this.invoiceData.items.push({
    //     id: "",
    //     name: "",
    //     purchasePrice: 0,
    //     qty: 1,
    //     computedPrice: "0.00",
    //     description: "",
    //     tax: 0,
    //     profit: 0,
    //     discount: 0,
    //   });
    // },
    validateQuantity(index) {
      const item = this.invoiceData.items[index];
      if (item.qty < 1) {
        this.quantityError = "Quantity must be 1 or more";
      } else {
        this.quantityError = "";
      }
    },
    success() {
      this.$swal({
        title: "PurchaseOrder!",
        text: "You have successfully added the Purchase Order!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(this.$router.push({ name: "purchaseorders-list" }));
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },
    addSalesOrder: debounce(function () {
      this.loadingButton = true;
      const loader = customLoader('Please wait while we save your order.');
      //let isValid = this.$refs.purchaseorder.validate();
      this.$refs.purchaseorder.validate().then((isValid) => {
        if (!isValid) {
          // Find the first invalid field
          const firstErrorField = this.$el.querySelector(".text-danger");
          if (firstErrorField) {
            // Scroll to the first invalid field
            firstErrorField.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
            // Set focus on the first invalid field
            firstErrorField.focus();
          }
          loader.close();
        } else {
          if (this.invoiceData.items.length === 0) {
            loader.close();
            customErrorMessage("Cannot add order without product");
            return false;
          } else {
            let payload = {
              id: this.$route.params.id,
              status: 0,
              supplierId: this.whenSelected.id,
              issueDate: this.issuedDate,
              orderNumber: this.orderNumber,
              salesPersonId: this.salesPersonId,
              paymentMethod: "string",
              dueDate: this.dueDate,
              subTotal: this.subTotal, // Use totalPrice here
              discount: 0,
              tax: this.salesTax,
              total: this.totalCost,
              hidePrice: this.hidePrice,
              note: this.purchaseorderId.note,
              warehouseId: this.warehouseId,
              purchaseOrderItems: this.invoiceData.items.map((event) => ({
                itemId: event.value,
                itemName: event.name,
                cost: event.purchase,
                quantity: event.qty,
                price: event.purchase * event.qty,
                discount: 0,
                description: event.description,
                isActive: true,
              })),
            };
            this.updatePurchaseOrdersAction(payload)
              .then(() => {
                loader.close();
                this.loadingButton = true;
                this.success();
              })
              .catch((error) => {
                loader.close();
                this.loadingButton = false;
                this.error(error);
              })
              .finally(() => {
                loader.close();
                this.loading = false; // Set the loading flag to false after the API call is completed
              });
          }
        }
      });

      this.loadingButton = false;
    }, 300),
    togglePrice() {
      this.isVisible = !this.isVisible;
    },
    updateItemForm(index, val) {
    console.log("🚀 ~ updateItemForm ~ index:", index);
    console.log("🚀 ~ updateItemForm ~ val:", val);

    if (!val) {
      console.error("updateItemForm: Received invalid value", val);
      return;
    }

    if (!this.invoiceData.items[index]) {
      console.error(`updateItemForm: No item found at index ${index}`);
      return;
    }

    // Update item properties with selected value
    this.$set(this.invoiceData.items, index, {
      ...this.invoiceData.items[index], // Keep existing properties
      value: val.value,
      name: val.itemTitle,
      cost: val.cost || 0,
      qty: 1, // Default quantity to 1
      price: val.cost || 0,
      description: val.description || "",
      purchase: val.purchase || 0
    });

    console.log("Updated invoiceData.items:", this.invoiceData.items);
  }
  },
  async mounted() {
    this.getSalesPersonListAction();
    await this.getRawMaterialListAction();

    await this.getProductListAction();
  

    await this.getSupplierListAction().then(() => {
      this.SupplierList.map((v, i) =>
        this.optionsCustomer.push({
          value: v.id,
          text: `${v.name}`,
        })
      );
    });
    this.optionsCustomer = fnSortingDropdown(this.optionsCustomer);

// Add these lines to process URL itemIds
  if (this.ids.length > 0) {
    this.optionsProduct = this.RawMaterialList.filter((v) => v.type !== 4).map(
      (v) => ({
        qty: 1,
        value: v.id,
        itemTitle: `${v.name}`,
        categoryName: v.categoryName || "-",
        subCategoryName: v.subCategoryName || "-",
        cost: v.salePrice,
        tax: v.saleTaxPercentage,
        purchase: v.purchasePrice,
        profit: v.markUpPercentage,
        description: v.description,
      })
    );
    await this.initializeItemData();
  }else{
    this.optionsProduct = this.ProductList.filter((v) => v.type !== 4).map(
      (v) => ({
        qty: 1,
        value: v.id,
        itemTitle: `${v.name}`,
        categoryName: v.categoryName || "-",
        subCategoryName: v.subCategoryName || "-",
        cost: v.salePrice,
        tax: v.saleTaxPercentage,
        purchase: v.purchasePrice,
        profit: v.markUpPercentage,
        description: v.description,
      })
    );
  }

  if(this.$route.params.id)
  {
    await this.getPurchaseOrdersByIDAction(this.$route.params.id)
      .then(() => {
        //this.getSupplierByIDAction(this.purchaseorderId.supplierId);

        this.whenSelected = this.SupplierList.find(supplier => supplier.id === this.purchaseorderId.supplierId);

        this.salesPersonId = this.purchaseorderId.salesPersonId;
        this.dueDate = this.purchaseorderId.dueDate;
        this.issuedDate = this.purchaseorderId.issueDate;
        this.orderNumber = this.purchaseorderId.orderNumber;
        this.hidePrice = this.purchaseorderId.hidePrice;
        this.note  = this.purchaseorderId.note;
        this.invoiceData.items = this.purchaseorderId.purchaseOrderItems.map(
          (event) => ({
            value: event.itemId,
            id: `${event.itemName}`,
            name: event.itemName,
            singleId: event.id,
            tax: event.saleTaxPercentage,
            cost: event.cost,
            profit: event.markUpPercentage,
            description: event.description,
            qty: event.quantity,
            purchase: event.cost,
          })
        );
      })
      .catch((error) => {
        console.error("Error fetching purchase order:", error);
      });
  }
    

    this.optionsSalesPerson = this.SalesPersonList.map((v) => ({
      value: v.id,
      text: `${v.firstName} ${v.lastName}`,
    }));

    // Ensure unique product list
    this.optionsProduct = this.optionsProduct.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.value === item.value)
    );

    this.optionsSalesPerson = fnSortingDropdown(this.optionsSalesPerson);
    this.optionsProduct = fnSortingDropdown(
      this.optionsProduct,
      "asc",
      "itemTitle"
    );
  },
  // setup() {
  //   //const { root } = context;
  //   const itemFormBlankItem = {
      // item: null,
      // value: null,
      // name: "",
      // computedPrice: 0,
      // purchase: 0,
      // qty: 1,
      // profit: 0,
      // description: "",
      // cost: 0,
  //   };

  //   const invoiceData = ref({
  //     items: [JSON.parse(JSON.stringify(itemFormBlankItem))],
  //   });

  //   const updateItemForm = (index, val) => {
  //     console.log("🚀 ~ updateItemForm ~ index:", index);
  //     console.log("🚀 ~ updateItemForm ~ val:", val);
  //     if (!val) {
  //       console.error("updateItemForm: Received invalid value", val);
  //       return;
  //     }

  //     if (!invoiceData.value.items || !Array.isArray(invoiceData.value.items)) {
  //       console.error("invoiceData.value.items is not an array");
  //       return;
  //     }

  //     invoiceData.value.items[index].cost = val.cost;
  //     invoiceData.value.items[index].qty = val.qty;
  //     invoiceData.value.items[index].value = val.value;
  //     invoiceData.value.items[index].tax = val.discount;
  //     invoiceData.value.items[index].profit = val.discountType;
  //     invoiceData.value.items[index].tax = val.tax;
  //     invoiceData.value.items[index].profit = val.profit;
  //     invoiceData.value.items[index].purchase = val.purchase;
  //     invoiceData.value.items[index].description = val.description;
  //   };
  //   return {
  //     invoiceData,
  //     updateItemForm,
  //     itemFormBlankItem,
  //   };
  // },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.invoice-total-wrapper {
  width: 100% !important;
  max-width: 30rem !important;
}

.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

#vs7__listbox {
  z-index: -1;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>
